"use client";

import { Mail, Phone } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
export default function LocationAndDetails() {
  const {
    ref: mapRef,
    isVisible: mapVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: cardRef,
    isVisible: cardVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section className="relative bg-background py-12 md:py-16 lg:py-24">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 lg:gap-12 items-center">
          {}
          <div ref={mapRef} className="lg:col-span-3 relative overflow-hidden rounded-lg shadow-medium">
            <div className={`transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${mapVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`} style={{
            transform: mapVisible ? "translateY(0)" : "translateY(2rem)"
          }}>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1458826/img/specialty_coffee_canada_location_map.png" alt="Specialty Coffee Canada Location - Toronto, Ontario" className="w-full h-[400px] md:h-[500px] lg:h-[600px] object-cover rounded-lg" />
            </div>
          </div>

          {}
          <div ref={cardRef} className="lg:col-span-2">
            <Card className={`shadow-soft hover:shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${cardVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
              <CardContent className="space-y-6">
                <div>
                  <h2 className="text-2xl md:text-3xl font-display font-bold text-foreground mb-2">
                    Get in Touch
                  </h2>
                  <p className="text-muted-foreground text-sm md:text-base">
                    Toronto, Ontario, Canada
                  </p>
                </div>

                {}
                <div className="flex items-start gap-4 group">
                  <div className="p-3 rounded-md bg-primary-light transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] group-hover:rotate-[15deg] group-hover:shadow-[0_0_20px_rgba(222,159,82,0.4)]">
                    <Mail className="w-5 h-5 text-primary" />
                  </div>
                  <div className="flex-1">
                    <p className="text-xs uppercase tracking-wide text-muted-foreground mb-1">
                      Email
                    </p>
                    <Link to="mailto:contact@specialtycoffeecanada.ca" className="text-foreground hover:text-primary transition-colors duration-[var(--duration-fast)] font-medium break-all">
                      contact@specialtycoffeecanada.ca
                    </Link>
                  </div>
                </div>

                {}
                <div className="flex items-start gap-4 group">
                  <div className="p-3 rounded-md bg-secondary-light transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] group-hover:rotate-[15deg] group-hover:shadow-[0_0_20px_rgba(72,187,160,0.4)]">
                    <Phone className="w-5 h-5 text-secondary" />
                  </div>
                  <div className="flex-1">
                    <p className="text-xs uppercase tracking-wide text-muted-foreground mb-1">
                      Phone
                    </p>
                    <Link to="tel:+14165552633" className="text-foreground hover:text-secondary transition-colors duration-[var(--duration-fast)] font-medium">
                      (416) 555-COFFEE
                    </Link>
                  </div>
                </div>

                {}
                <div className="pt-4 border-t border-border">
                  <p className="text-xs uppercase tracking-wide text-muted-foreground mb-2">
                    Office Hours
                  </p>
                  <p className="text-sm text-foreground leading-relaxed">
                    Monday to Friday: 8am - 6pm<br />
                    Saturday: 9am - 4pm<br />
                    Sunday: Closed
                  </p>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>;
}